import arrow from './../../assets/webp/services/arrow.webp'
import smartphone from './../../assets/webp/services/smartphone.webp'
import performance from './../../assets/webp/services/performance.webp'
import hierarchy from './../../assets/webp/services/hierarchy.webp'
import server from './../../assets/webp/services/server.webp'
import credit from './../../assets/webp/services/credit.webp'
import setting from './../../assets/webp/services/setting.webp'
import digital from './../../assets/webp/services/digital.webp'
import solution from './../../assets/webp/services/solution.webp'

export const assets = {
    arrow,
    smartphone,
    performance,
    hierarchy,
    server,
    credit,
    setting,
    digital,
    solution,
}